



import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";

@Component
export default class AppealsEmail extends Vue {
    @Prop() email: string;
    @Prop({ default: 'Refund appeal' }) subject: string;
    
    getSubject() {
        return encodeURIComponent(this.subject);
    }
    
    getUrl() {
        return `mailto:${this.email}?subject=${this.getSubject()}`;
    }
}
